import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { fr } from "date-fns/locale";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import formatToISODate from "../formatDateISO";

import { Dropdown } from 'primereact/dropdown';


const apiUrl = process.env.REACT_APP_API_URL;


export default function HistoriqueMailsDem() {

const [loading, setLoading] = useState(true);

const [historiqueMailsDem, setHistoriqueMailsDem] = useState("");
  const [filtreHistoriqueMailsDem, setFiltreHistoriqueMailsDem] = useState(historiqueMailsDem);

const [rechercheMail,setRechercheMail] = useState("");
const [selectedDate,setSelectedDate] = useState("");

const[selectedSujet,setSelectedSujet] = useState("");


const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

   
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};



const dateTo = new Date();
const dateToFormatted = formatDate(dateTo);


const dateFrom = new Date();
dateFrom.setTime(dateFrom.getTime() - (30 * 24 * 60 * 60 * 1000));
const dateFromFormatted = formatDate(dateFrom);

 
useEffect(() => {
  const fetchMails = async () => {
    try {
      const proxyUrl = `${apiUrl}IHM/api/apiMail/getDemMail.php`; 
      
      const response = await axios.post(proxyUrl, {
        query: "déménagement",
        date_from: dateFromFormatted,
        date_to: dateToFormatted,
      });

      setHistoriqueMailsDem(response.data || []);
      setFiltreHistoriqueMailsDem(response.data || []);
    } catch (error) {
      console.error("Erreur via Proxy PHP:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchMails();
}, [selectedDate]);
 
  useEffect(() => {
    if (!rechercheMail) {
      setFiltreHistoriqueMailsDem(historiqueMailsDem);
    } else {
      const filtered = historiqueMailsDem.filter((mail) =>
        mail.email.toLowerCase().includes(rechercheMail.toLowerCase())
      );
      setFiltreHistoriqueMailsDem(filtered);
    }
  }, [rechercheMail, historiqueMailsDem]);


useEffect (() =>{
  let filteredList = historiqueMailsDem;

if (selectedSujet) {
         filteredList = filteredList.filter(
           (fiche) => fiche.subject === selectedSujet
         );
       }

setFiltreHistoriqueMailsDem(filteredList);
},[selectedSujet,historiqueMailsDem]);





 const etatOptions = [
  { label: "Zotdevis - Relance concernant votre devis de déménagement", value: "Zotdevis - Relance concernant votre devis de déménagement" },
  { label: "Tentative de prise de contact – Devis déménagement", value: "Tentative de prise de contact – Devis déménagement" },
  { label: "ZotDevis - Votre retour suite à votre déménagement 🙏", value: "ZotDevis - Votre retour suite à votre déménagement 🙏" },
  { label: "Rappel pour confirmation de déménagement – Zotdevis", value: "Rappel pour confirmation de déménagement – Zotdevis" },
 
];




  const enteteTableau = () => (
    <div className="flex justify-content-end ">




 <Dropdown
          value={selectedSujet}
          onChange={(e) => setSelectedSujet(e.value)}
          options={etatOptions}
          placeholder="Sélectionner un sujet"
          editable
          style={{
            height: 45,
            border: "none",
            boxShadow: "none",
          }}
        />




      <IconField iconPosition="left">
      <InputIcon className="pi pi-search" />
        <InputText
          value={rechercheMail}
          onChange={(e) => setRechercheMail(e.target.value)}
          placeholder="Rechercher destinataire"
        />
        </IconField>
   
    </div>
  );

  return (
    <div className="content-right">
    <DataTable
      paginator
      value={filtreHistoriqueMailsDem}
      rows={25}
      header={enteteTableau}
      size="small"
      rowsPerPageOptions={[5, 10, 25, 50]}
      tableStyle={{ minWidth: "50rem" }}
      scrollable
      scrollDirection="horizontal"
      paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
      paginatorRight={
        <span style={{ margin: "10px", fontWeight: "bold" }}>
          Résultats : {filtreHistoriqueMailsDem.length}
        </span>
      }
      emptyMessage="Aucun mail pour le moment"
      loading={loading}
      loadingIcon="pi pi-spin pi-spinner"
    >
      <Column
        field="ts"
        header="Date"
        body={(row) => new Date(row.ts * 1000).toLocaleString()}
      />
      <Column field="email" header="Destinataire" />
      <Column field="subject" header="Sujet" />

      <Column
        field="opens"
        header="Stats"
        body={(row) => {
          return (
            <span>
              {row.opens} / {row.clicks}
            </span>
          );
        }}
      />
    </DataTable>
    </div>
  );

}
